<!-- @Description 工业级智能体 -->
<template>
  <div class="product-manufacture">
    <div class="info">
      <div class="title">工业级智能体</div>
      <div class="content">
        基于认知智能算法平台，嵌入行业专属运营知识，专为复杂工业环境与长流程制造场景打造。产品覆盖制造全流程，支持智能控制、质量预测、运维监控与生产优化，助力企业提升效率、增强品控，减少对经验决策的依赖。
      </div>
    </div>
    <div class="product">
      <div class="title">产品矩阵</div>
      <div
        class="product-catgory"
        v-for="cat in categories"
        :key="cat.key"
      >
        <div
          class="product-catgory-item"
          @click="goCategory(cat.key)"
        >
          <div
            class="product-catgory-item-title"
            :class="
              cat.bgType === 1
                ? 'product-catgory-item-title1'
                : 'product-catgory-item-title2'
            "
          >
            <div class="title-row">
              <span class="title-text">{{ cat.title }}</span>
              <img
                :src="arrowIcon"
                class="title-arrow"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cases">
      <div class="title">客户案例</div>
      <Case
        :data.sync="case_list"
        :is-categorized="true"
        class="case-list"
      />
    </div>
    <div class="more">
      更多案例请联系我们
    </div>
    <div class="visitingCard">
      <VisitingCard :data="visitlist" />
    </div>
  </div>
</template>
<script>
import Case from "@/components/customerCase.vue";
import VisitingCard from "@/components/visitingCard.vue";
import arrowIcon from "@/../static/img/other/arrow.svg";
import { MANUFACTURE_CATEGORIES } from "./categoryData";

export default {
  name: "product-manufacture",
  components: {
    Case,
    VisitingCard
  },
  data() {
    return {
      arrowIcon,
      categories: MANUFACTURE_CATEGORIES,
      case_list: [
        {
          category: "材料研发",
          cases: [
            {
              title: "某钢铁集团高碳钢材料性能预测项目",
              img: "../../../static/img/product/AI材料研发智能平台案例封面.jpg",
              video: "",
              content: `某钢铁集团高碳钢材料性能预测项目，结合生产工艺和性能表征数据，构建企业级材料数据库。利用材料性能预测、工艺参数优化等功能，提升生产稳定性和产品性能一致性，同时辅助研发新钢种，缩短研发周期。`,
              isplay: false
            }
          ]
        },
        {
          category: "配料优化",
          cases: [
            {
              title: "焦化行业智能配煤系统",
              img: "../../../static/img/product/product_manufacture_case2.png",
              video:
                "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/video/zhizao/zhinengjiaohua.mp4",
              content: `某集团智能配煤项目建设结合焦化厂的生产工艺条件，利用智能配煤系统的<strong>${"配煤结构优化、焦炭质量预测、煤焦资源管理、煤场&筒仓智能管理"}</strong>等功能，实现<strong>${"降本增效"}</strong>及<strong>${"智能化管理"}。</strong>`,
              isplay: false
            }
          ]
        },
        {
          category: "质量管控",
          cases: [
            {
              title: "连铸质量判定系统",
              img: "../../../static/img/product/product_manufacture_case3.svg",
              video: "",
              content: `某大型钢铁企业力求高效化精益生产过程，华院计算为其建设一套连铸质量预判及切割优化系统，有效指导板坯的切割优化，从而<strong>${"确保生产的连续性，提高板坯收得率，增加经济效益"}</strong>。`,
              isplay: false
            },
            {
              title: "表面缺陷检测系统",
              img: "../../../static/img/product/product_manufacture_case4.svg",
              video: "",
              content: `某大型钢铁集团联合华院计算建设表面缺陷智能检测项目，对热轧产线的产品表面缺陷进行实时检测，从而为生产或质检工作提供技术支持，<strong>${"提升产品质量管控水平，保证产品合格率"}</strong>。`,
              isplay: false
            }
          ]
        },
        {
          category: "智慧安全",
          cases: [
            {
              title: "飞钢智能安监系统",
              img: "../../../static/img/product/product_manufacture_case1.png",
              video:
                "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/video/zhizao/feiganganjian.mp4",
              content: `<strong>${"中国某钢集团"}</strong>联合华院计算开发建设“大棒热轧线飞钢监测”项目，实现7 X 24小时在线实时监测大棒热轧产线轧制状态，在异常状态下<strong>${"毫秒级响应"}</strong>自动控制生产线飞剪系统及主传动，并<strong>${"预警确保生产安全"}。</strong>`,
              isplay: false
            },
            {
              title: "厂区安全智能巡检系统",
              img: "../../../static/img/product/product_manufacture_case5.svg",
              video: "",
              content: `某钢铁集团下属厂区智慧安全项目上线，由华院计算研发的厂区安全智能巡检算法模型，成功在其智慧安全巡检平台中应用，从而<strong>${"强化巡检质量、提高巡检效率"}</strong>，真正赋能管理，助力企业<strong>${"实现安全生产"}</strong>。`,
              isplay: false
            }
          ]
        }
      ],
      visitlist: []
    };
  },
  methods: {
    goCategory(key) {
      this.$router.push({
        name: "product_manufacture_category",
        params: { key }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.product-manufacture {
  width: 100%;
  padding: 96px 0px 0px;
  .info {
    width: 100%;
    background: url("../../../../static/img/product/product_manufacture_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;
    padding-bottom: 44px;
    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }
    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }
  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }
    .product-catgory {
      .product-catgory-item {
        cursor: pointer;
        .product-catgory-item-title {
          position: relative;
          width: 100%;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 64px;
          box-sizing: border-box;
          .title-row {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .title-text {
            font-size: 32px;
            color: #08204d;
            line-height: 44px;
          }
          .title-arrow {
            flex-shrink: 0;
            height: 16px;
            width: auto;
            opacity: 0.72;
            transition: opacity 0.25s ease;
            animation: arrowNudgeRight 2.2s ease-in-out infinite;
          }
        }
        &:active .title-arrow {
          animation: none;
          opacity: 1;
          transform: translateX(4px);
        }
        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }
        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }
  @keyframes arrowNudgeRight {
    0%,
    100% {
      transform: translateX(-4px);
      opacity: 0.45;
    }
    50% {
      transform: translateX(6px);
      opacity: 0.85;
    }
  }
  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px 0;
    }
  }
  .more {
    height: 52px;
    font-weight: 400;
    font-size: 22px;
    color: #97a2b5;
    line-height: 52px;
    text-align: center;
    font-style: normal;
    margin: 16px 0;
  }
  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/manufacture/index.vue